import { jsx as _jsx } from "react/jsx-runtime";
import * as React from "react";
var AuthLoader = function (props) {
    var navigate = props.navigate;
    React.useEffect(function () {
        var timeout = setTimeout(function () {
            navigate();
        });
        return function () { return clearTimeout(timeout); };
    }, [navigate]);
    return _jsx("span", { className: "login-loader" });
};
export default AuthLoader;
